// ---------------------------------------------------------------------------
// Plural rules
// ---------------------------------------------------------------------------
// A "{s}" suffix token cannot express plurals outside English -- it interpolates the literal
// English letter s, which produced "видеоs" and "크레딧s" in shipped builds. Real CLDR
// categories come from Intl.PluralRules, which knows that Russian needs one/few/many
// (1 кредит, 2 кредита, 5 кредитов) and that Japanese needs exactly one form.
//
// Syntax:  {n, plural, one {# credit} other {# credits}}
//          '#' is replaced by the number. Categories a language does not use are ignored;
//          a category it needs but the string omits falls back to `other`.
const PLURAL_RE = /\{(\w+),\s*plural,\s*((?:\s*\w+\s*\{[^{}]*\})+)\}/g;
const BRANCH_RE = /(\w+)\s*\{([^{}]*)\}/g;

const pluralRules = {};
function selectCategory(lang, count) {
  try {
    if (!pluralRules[lang]) pluralRules[lang] = new Intl.PluralRules(lang);
    return pluralRules[lang].select(count);
  } catch {
    return count === 1 ? 'one' : 'other';   // Intl missing or unknown locale
  }
}

export function applyPlurals(str, vars, lang) {
  if (!vars || str.indexOf(', plural,') === -1) return str;

  return str.replace(PLURAL_RE, (whole, varName, body) => {
    const raw = vars[varName];
    const count = Number(raw);
    if (!Number.isFinite(count)) return whole;   // nothing sensible to select on

    const branches = {};
    let m;
    BRANCH_RE.lastIndex = 0;
    while ((m = BRANCH_RE.exec(body)) !== null) branches[m[1]] = m[2];

    // An exact-value branch (=0, =1) wins over the category, as in ICU.
    const chosen = branches[`=${count}`]
      ?? branches[selectCategory(lang, count)]
      ?? branches.other
      ?? '';
    return chosen.replaceAll('#', String(count));
  });
}

